export default "__VITE_ASSET__CBQrGUB5__"